import React, { memo } from "react";
import Head from "next/head";

import QuizContainer from "containers/QuizContainer";
import { translit } from "utils";
import _ from "lodash";

import {
  quizListUrl,
  singleQuestUrl,
  questEventsListUrl,
  reviewsListUrl,
  statisticListUrl,
  questRaitingUrl,
} from "utils/api/requestUrls";

const QuizPage = (props: any) => {
  const title = `Квест ${props?.questFirstData?.name} на questminsk.by`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta
          name="description"
          content={`Забронировать квест ${props?.questFirstData?.name} на questminsk.by. Цены, отзывы, расписание и бронирование онлайн на сайте questminsk.by`}
        />
      </Head>

      <QuizContainer {...props} />
    </>
  );
};

export const getServerSideProps = async (context) => {
  const { req, res } = context;
  let quizId: any;

  const questListResponse = await fetch(quizListUrl(null, null));
  const questListFirstData = await questListResponse.json();

  if (!!questListFirstData?.content?.length) {
    questListFirstData.content.map((item) => {
      if (translit(item.name) === context.query.quizId) {
        return (quizId = item.id);
      }
    });
  }

  const questResponse = await fetch(singleQuestUrl(quizId));
  const questFirstData = await questResponse.json();

  const questEventsResponse = await fetch(questEventsListUrl(quizId));
  const questEventsFirstData = await questEventsResponse?.json();

  const reviewsResponse = await fetch(reviewsListUrl(quizId));
  const reviewsFirstData = await reviewsResponse?.json();

  const statisticResponse = await fetch(statisticListUrl(quizId));
  const statisticFirstData = await statisticResponse?.json();

  const raitingResponse = await fetch(questRaitingUrl(quizId));
  const raitingJSON = await raitingResponse?.json();

  const responseBody = Object.values(
    _.groupBy(questEventsFirstData.content, "startDate")
  );

  if (req.headers.host.match(/^www/) !== null) {
    res.writeHead(301, {
      location: "https://" + req.headers.host.replace(/^www./, "") + req.url,
    });
    res.end();
  }

  return {
    props: {
      quizId,
      questFirstData,
      responseBody,
      questListFirstData,
      statisticFirstData,
      overallRating: raitingJSON,
      questEventsFirstData: questEventsFirstData?.content,
      reviewsFirstData: reviewsFirstData?.content,
    },
  };
};

export default memo(QuizPage);
